import axios from "axios";
import Crypto from "@/helper/crypto";
import moment from "moment-timezone";

// *From Auth - Data will be received from auth provider
const userDefaults = {
  id: 0, // From Auth
  name: "", // From Auth
  photoURL: "/images/logo/default-profile-pic.png", // From Auth
  status: "online",
  userRole: "customer",
  is_dark_mode: false,
  contact_no: null,
};

const store = {
  state: {
    token: localStorage.getItem("token") ? localStorage.getItem("token") : null,
    appActiveUser: null,
    locale: localStorage.getItem("locale") ? localStorage.getItem("locale") : "en",
    selectedCountry: localStorage.getItem("selectedCountry")
      ? JSON.parse(localStorage.getItem("selectedCountry"))
      : null,
    selectedCountryCode: localStorage.getItem("countryCode") ? localStorage.getItem("countryCode") : null,
    initialUserState: JSON.parse(JSON.stringify(userDefaults)),
  },
  getters: {
    getUser(state) {
      return state.appActiveUser;
    },
    isLoggedIn(state) {
      return !!state.token;
    },
    getUserCountry(state) {
      return state.selectedCountry;
    },
    isCustomer(state) {
      return state.appActiveUser ? state.appActiveUser.is_customer : false;
    },
    isDriver(state) {
      return state.appActiveUser ? state.appActiveUser.is_driver : false;
    },
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = Crypto.encrypt(token);
      localStorage.setItem("token", state.token);
    },
    UPDATE_USER_INFO(state, payload) {
      // Get Data localStorage
      const userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.appActiveUser;

      for (const property of Object.keys(payload)) {
        if (payload[property] != null) {
          // If some of user property is null - user default property defined in state.appActiveUser
          state.appActiveUser[property] = payload[property];
          // Update key in localStorage
          userInfo[property] = payload[property];
        }
      }
      // Store data in localStorage
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    },
    DEFINE_ACCOUNT(state, payload) {
      state.appActiveUser = {
        id: payload.id,
        name: payload.name,
        email: payload.email,
        phone_number: payload.phone_number,
        //country: payload.country,
        status: payload.status,
        is_customer: payload.is_customer,
        is_driver: payload.is_driver,
        userRole: "customer",
        google_id: payload.google_id,
      };

      if (!state.selectedCountry) {
        state.selectedCountry = payload.country;
        state.selectedCountryCode = payload.country.code;
        localStorage.setItem("selectedCountry", JSON.stringify(payload.country));
        localStorage.setItem("countryCode", payload.country.code);
      }

      const userInfo = state.appActiveUser;

      moment.tz.setDefault(state.selectedCountry ? state.selectedCountry.timezone_name : "Asia/Singapore");
    },
    CHANGE_COUNTRY_SELECTION(state, country) {
      state.selectedCountry = country;
      state.selectedCountryCode = country.code;
      localStorage.setItem("selectedCountry", JSON.stringify(country));
      localStorage.setItem("countryCode", country.code);
    },
    CHANGE_LOCALE(state, payload) {
      state.locale = payload.locale;
      localStorage.setItem("locale", payload.locale);
    },
    REMOVE_ACCOUNT_SESSION(state, payload) {
      state.token = null;
      state.appActiveUser = state.initialUserState;
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      google.accounts.id.disableAutoSelect();
    },
  },
  actions: {
    setUser({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .create()
          .get(this._vm.$endpoints.user_profile, {
            headers: {
              Authorization: "Bearer " + Crypto.decrypt(payload.token),
              "Secret-Key": process.env.MIX_APP_SECRET,
            },
          })
          .then((res) => {
            let response = res.data.data;
            if (payload.token) {
              commit("SET_TOKEN", Crypto.decrypt(payload.token));
            }
            commit("DEFINE_ACCOUNT", response);
            resolve(res);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    retrieveUserInfo({ commit, state, getters }) {
      if (getters.isLoggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .get(this._vm.$endpoints.user_profile)
            .then((res) => {
              let response = res.data.data;
              commit("DEFINE_ACCOUNT", response);
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      }
    },
    checkUserExist({ commit, state, getters, context }, param) {
      return new Promise((resolve, reject) => {
        axios
          .post(this._vm.$endpoints.user_check_exist, param)
          .then((res) => {
            const response = res.data.data;
            if (response.exist) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    removeUserInfo({ commit, state }, payload) {
      commit("REMOVE_ACCOUNT_SESSION", payload);
    },
    changeCountrySelection({ commit, state }, country) {
      commit("CHANGE_COUNTRY_SELECTION", country);
    },
    initializeCountryLocation({ commit, state, getters, dispatch }) {
      return new Promise((resolve, reject) => {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        dispatch("initializeCountry")
          .then((res) => {
            let locationCountry = getters.countryList.find((country) => country.timezone_name == timezone);
            if (!locationCountry) {
              locationCountry = getters.countryList.find((country) => country.code == "SG"); //Default to SG
            }

            dispatch("changeCountrySelection", locationCountry);
          })
          .catch((err) => {
            console.log(err);
          });
      }).catch(function(err) {
        console.log(err);
      });
    },
    setMyIPAddress({ commit, state }) {
      return new Promise((resolve, reject) => {
        axios
          .create()
          .get("https://api.ipify.org/?format=json")
          .then((res) => {
            let response = res.data;
            commit("SET_IP_ADDRESS", response);

            resolve(response);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
  },
};

export default store;
